import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { CrudTable, type FieldDef } from "@/features/admin/components/CrudTable";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/groups")({
  component: AdminGroups,
});

function AdminGroups() {
  const [opts, setOpts] = useState<{
    courses: { value: string; label: string }[];
    instructors: { value: string; label: string }[];
  } | null>(null);

  useEffect(() => {
    (async () => {
      const [c, i] = await Promise.all([
        supabase.from("courses").select("id,name").order("name"),
        supabase
          .from("user_roles")
          .select("user_id, profiles!inner(full_name)")
          .eq("role", "instructor"),
      ]);
      setOpts({
        courses: (c.data ?? []).map((r) => ({ value: r.id as string, label: r.name as string })),
        instructors: (i.data ?? []).map((r) => ({
          value: r.user_id as string,
          label:
            (r.profiles as unknown as { full_name: string | null })?.full_name ||
            (r.user_id as string).slice(0, 8),
        })),
      });
    })();
  }, []);

  if (!opts)
    return (
      <div className="flex justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );

  const fields: FieldDef[] = [
    { key: "name", label: "اسم الجروب", required: true },
    { key: "course_id", label: "الكورس", type: "select", options: opts.courses, required: true },
    { key: "instructor_id", label: "المدرس", type: "select", options: opts.instructors },
    { key: "schedule_day", label: "اليوم" },
    { key: "schedule_time", label: "الوقت" },
    { key: "capacity", label: "السعة", type: "number" },
    { key: "is_active", label: "نشط", type: "switch", defaultValue: true },
  ];

  return (
    <CrudTable
      title="Groups"
      table="groups"
      fields={fields}
      orderBy={{ column: "created_at", ascending: false }}
      columns={[
        { key: "name", label: "Name" },
        { key: "schedule_day", label: "Day" },
        { key: "schedule_time", label: "Time" },
        {
          key: "course_id",
          label: "Course",
          render: (r) => opts.courses.find((c) => c.value === r.course_id)?.label || "—",
        },
        {
          key: "instructor_id",
          label: "Instructor",
          render: (r) => opts.instructors.find((i) => i.value === r.instructor_id)?.label || "—",
        },
      ]}
    />
  );
}
